<template>
    <div class="memmber-accpaw-box">
        <div class="login-title">忘记密码</div>
        <div class="data-list-box">
            <a-form-model
                ref="memberForm"
                :model="member"
            >
                <a-form-model-item label="手机号码(+1)" prop="phone">
                    <a-input v-model="member.phone" type="number" class="input" placeholder="请输入手机号码"/>
                </a-form-model-item>
                <a-form-model-item label="新密码" prop="password">
                    <a-input v-model="member.password" class="input" type="password" autocomplete="off"
                             placeholder="请输入新密码 (6-18位)"/>
                </a-form-model-item>
                <a-form-model-item label="重复新密码" prop="checkPass">
                    <a-input v-model="member.checkPass" class="input" type="password" autocomplete="off"
                             placeholder="请输入重复新密码"/>
                </a-form-model-item>
                <a-form-model-item label="短信验证码" prop="code">
                    <a-input v-model="member.code" class="code-input" placeholder="请输入4位短信验证码"/>
                    <span :class="['code-btn',isCode ? 'code-active' : '']" @click="getCode">{{codeCountDown}}</span>
                </a-form-model-item>
                <a-form-model-item class="submit-btn" style="border: none;">
                    <a-button type="primary" @click="submitForm('memberForm')">确认提交</a-button>
                </a-form-model-item>
            </a-form-model>
            <div class="other-box">
                <div class="link-box">
                    <router-link to="/login/login">立即登录</router-link>
                    <router-link to="/login/register">立即注册</router-link>
                </div>
            </div>
        </div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
import Tabber from '@/components/Tabber.vue'

export default {
    name: 'AccPaw',
    components: {
        Tabber
    },
    data() { //默认数据
        return {
            member: { //用户信息
                phone: '',
                password: '',
                checkPass: '',
                code: ''
            },
            codeDown: null,
            isCode: true,
            downNum: 60,
            codeCountDown: '获取验证码',
        }
    },
    created() { //视图加载前执行
        let _this = this;
    },
    mounted() { //视图加载完成执行
        let _this = this;
    },
    methods: { //页面方法
        // 表单提交
        submitForm() {
            let _this = this;
            // 校验表单规则
            if (!_this._verification(_this.member)) {
                return false;
            }
            _this.loading = _this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._post_form('user/resetPassword', _this.member, res => {
                _this.$toast.success(res.msg, {
                    onClose: _this.$router.push({
                        path: '/login/login'
                    })
                });
                _this.loading.hide();
            })
        },

        //获取手机验证码
        getCode() {
            let _this = this;
            if (_this.member.phone == '' || _this.member.phone.length != 10) {
                _this.$toast.fail('手机号码不正确');
                return false;
            }
            if (_this.isCode) {
                _this._get('user/sendSmsCode', {
                    phone: _this.member.phone
                }, res => {
                    _this.$toast.success(res.msg, {
                        onClose: function () {
                            _this.isCode = false;
                            _this.countdown();
                        }
                    });
                })
            }
        },

        //倒计时
        countdown() {
            let _this = this;
            _this.codeCountDown = _this.downNum + 's';
            setTimeout(function () {
                if (_this.downNum > 1) {
                    _this.downNum--;
                    _this.countdown();
                } else {
                    _this.codeCountDown = '获取验证码';
                    _this.downNum = 0;
                    _this.isCode = true;
                }
            }, 1000);
        },

        // 规则校验
        _verification(data) {
            let _this = this;
            if (data.phone == '' || data.phone.length >= 12) {
                _this.$toast.fail('手机号码不正确');
                return false;
            }
            if (data.password == '' || data.password.length > 18 || data.password.length < 6) {
                _this.$toast.fail('密码不符合规则');
                return false;
            }
            if (data.password != data.checkPass) {
                _this.$toast.fail('两次密码不一致');
                return false;
            }
            if (data.code == '' || data.code.length > 5) {
                _this.$toast.fail('验证码不符合规则');
                return false;
            }
            return true;
        },
    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
    }
}
</script>
<style lang="scss">
@import "./accpaw.scss";
</style>
